import getDOMNode from './getDOMNode';

export default function initDOMNode(nodes, baseNode, css, type) {
  var media = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var support = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  var node = getDOMNode(nodes, baseNode, type, media, support);
  // in case that there is a node coming from server already
  // but rules are not matchnig
  if (node.textContent !== css) {
    node.textContent = css;
  }
}